/**
 * Framework-freie MusicXML-DOM-Helfer – öffentliche API des Pakets.
 *
 * Aufgeteilt nach Domänen (vorher EIN 2600-Zeilen-Modul); der Import-Pfad der ~28 Konsumenten
 * bleibt `@/composables/musicXmlDom`. Regel: geteilte Basis-Helfer in `core.ts`; gerichtete Geschwister-Imports ok, keine Zyklen.
 */
export * from './core';
export * from './barlines';
export * from './measureAttributes';
export * from './chordInference';
export * from './bass';
export * from './diatonic';
export * from './notes';
export * from './structure';
export * from './durations';
export * from './pickup';
export * from './meterChange';
export * from './lyrics';
export * from './clipboard';
export * from './fragment';
